// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import BlogListState from "@store/Framework/Store/Store/Pages/BlogList/BlogListState";

const initialState: BlogListState = {};

const actions = {};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type StoreBlogListActions = Parameters<typeof reducer>[1];
export default reducer;
